import { render, staticRenderFns } from "./NormalPrice.vue?vue&type=template&id=8c217d20"
import script from "./NormalPrice.vue?vue&type=script&lang=js"
export * from "./NormalPrice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports